import { Link } from "react-router-dom";

const F1 = "https://customer-assets-m6fa6gv7.emergentagent.net/wingman/a7d790a2-0920-433d-b5d4-1e925b54849f/attachments/97c0fb239683481b9f90a26c2ec1f1fe_IMG_20190818_204307_991.jpg";
const F2 = "https://customer-assets-m6fa6gv7.emergentagent.net/wingman/a7d790a2-0920-433d-b5d4-1e925b54849f/attachments/a7a8d05b4dc84715b01737b22c0f61f2_ws_banner_11.jpg";
const F3 = "https://customer-assets-m6fa6gv7.emergentagent.net/wingman/a7d790a2-0920-433d-b5d4-1e925b54849f/attachments/acd3039cdcde471eb4ae87e3bce775ae_Antonio%20e%20annapia.jpg";

const Block = ({ title, children, testId }) => (
  <section className="border-b border-[#2A2A2A]">
    <div className="max-w-4xl mx-auto px-5 lg:px-10 py-14" data-testid={testId}>
      <h2 className="font-display text-3xl sm:text-4xl font-bold mb-6">{title}</h2>
      <div className="space-y-4 text-base text-[#C9C4B8] leading-relaxed">{children}</div>
    </div>
  </section>
);

export default function ChiSiamo() {
  return (
    <div data-testid="chisiamo-page">
      <section className="border-b border-[#2A2A2A]">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6">
            <p className="text-xs uppercase tracking-[0.25em] text-[#E4BD44] mb-4">Chi Siamo</p>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight mb-6">
              C'era una volta<br />un'idea selvaggia.
            </h1>
            <p className="text-base text-[#C9C4B8] leading-relaxed mb-4">
              Nel 2020, in un periodo in cui il mondo si era fermato, Antonio Blandolino aveva una visione:
              un brand che non fosse solo ristorazione, non solo arte, non solo lifestyle. Qualcosa di più grande.
              Qualcosa di vivo. Scrisse il nome su un foglio: <em>Wildersquad</em>. Wild, perché il vero talento
              non si addomestica. Squad, perché nessuna avventura vale la pena di essere vissuta da soli.
            </p>
            <p className="font-display text-xl italic text-[#E4BD44]">Sei anni dopo, quella visione è diventata realtà.</p>
          </div>
          <div className="lg:col-span-6">
            <div className="art-frame aspect-[4/3] border border-[#2A2A2A]">
              <img src={F3} alt="Antonio e Annapia al caminetto" data-testid="chisiamo-hero-photo" />
            </div>
            <p className="text-xs text-[#9a9484] mt-3 font-mono-ws">Antonio e Annapia — due wilder, una squadra</p>
          </div>
        </div>
      </section>

      <Block title="Antonio e Annapia — due wilder, una squadra." testId="block-squadra">
        <p>
          Tutto è cominciato ad Otranto, nell'estate del 2021. Antonio — nato a Scorrano, ha studiato
          all'Istituto Alberghiero di Otranto — chef, stratega, sognatore irrequieto.
          Annapia: solare, selvaggia, con una laurea in lingue e la curiosità di chi ha ancora tutto da scoprire.
          Si sono incontrati e non si sono più fermati.
        </p>
        <p>
          Da allora hanno attraversato il mondo insieme: le Canarie, la Thailandia, il Marocco, la Francia,
          la Spagna, la Svizzera, la Repubblica Ceca, la Grecia. Ogni viaggio ha lasciato qualcosa nel piatto,
          nel progetto, nel DNA di Wildersquad.
        </p>
        <p>
          Oggi lavorano fianco a fianco all'Agriturismo La Tresenda di Livigno, dove da due anni costruiscono
          ogni giorno la versione migliore di ciò che stanno creando. Antonio porta la visione culinaria e la
          regia del progetto. Annapia è la colonna portante: receptionist, manager, poliglotta, e l'anima che
          tiene tutto insieme con grazia e forza.
        </p>
        <div className="grid grid-cols-2 gap-5 pt-4" data-testid="chisiamo-gallery">
          <figure>
            <div className="art-frame aspect-[3/4] border border-[#2A2A2A]"><img src={F1} alt="Antonio, chef con il fuoco" /></div>
            <figcaption className="text-xs text-[#9a9484] mt-2 font-mono-ws">Antonio — mani nel fuoco</figcaption>
          </figure>
          <figure>
            <div className="art-frame aspect-[3/4] border border-[#2A2A2A]"><img src={F2} alt="Antonio impiatta a un evento" /></div>
            <figcaption className="text-xs text-[#9a9484] mt-2 font-mono-ws">Antonio all'opera — evento Wildersquad</figcaption>
          </figure>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 pt-5" data-testid="chisiamo-tresenda">
          <figure>
            <div className="art-frame aspect-[3/4] border border-[#2A2A2A] overflow-hidden">
              <img src="https://customer-assets-m6fa6gv7.emergentagent.net/wingman/a7d790a2-0920-433d-b5d4-1e925b54849f/attachments/9896dac443fc434d8fea778fcaf87973_wildersquad%20tresenda.jpg" alt="La squadra Wildersquad alla Tresenda" loading="lazy" className="w-full h-full object-cover" />
            </div>
            <figcaption className="text-xs text-[#9a9484] mt-2 font-mono-ws">La squadra Wildersquad — La Tresenda</figcaption>
          </figure>
          <figure>
            <div className="art-frame aspect-[3/4] border border-[#2A2A2A] overflow-hidden">
              <img src="https://customer-assets-m6fa6gv7.emergentagent.net/wingman/a7d790a2-0920-433d-b5d4-1e925b54849f/attachments/1435d11653bb4979b9c9d8f314cb5158_wildersquad%20tresenda%202.jpg" alt="Wildersquad in cucina alla Tresenda" loading="lazy" className="w-full h-full object-cover" />
            </div>
            <figcaption className="text-xs text-[#9a9484] mt-2 font-mono-ws">Wildersquad in cucina — La Tresenda</figcaption>
          </figure>
        </div>
      </Block>

      <Block title="Annapia — la forza silenziosa." testId="block-annapia">
        <p>
          C'è chi costruisce i muri e chi li rende abitabili. Annapia è quella persona. Laureata in lingue e
          traduzione russo-inglese, parla il mondo con naturalezza e lo accoglie con calore. In Wildersquad è il
          punto di contatto tra la visione di Antonio e le persone: gestisce, coordina, ispira. Selvaggia nella
          sua libertà, concreta nella sua intelligenza. Senza di lei, Wildersquad sarebbe solo un'idea bella.
          Con lei, è un progetto che cammina.
        </p>
      </Block>

      <Block title="L'arte nel sangue — Italo Blandolino." testId="block-italo">
        <p>
          Wildersquad non sarebbe Wildersquad senza l'arte. Italo Blandolino, padre di Antonio, è l'artista che
          ha ispirato uno dei format più originali del brand: <em>Assaggi d'Arte</em>, cene dove ogni piatto nasce
          da un quadro, dove la cucina e la pittura si parlano, si intrecciano, si completano. Le sue opere fondono
          tradizione e innovazione, temi classici e spirituali con un linguaggio contemporaneo. Non decorazione:
          identità. Ogni riproduzione numerata, ogni NFT certificato su Crypto.com, porta con sé un pezzo di questa storia.
        </p>
        <Link to="/galleria" className="btn-outline !py-2.5 !px-5 text-xs mt-2 inline-flex" data-testid="chisiamo-galleria-link">Visita la Galleria</Link>
      </Block>

      <section>
        <div className="max-w-4xl mx-auto px-5 lg:px-10 py-14 text-center" data-testid="block-visione">
          <h2 className="font-display text-3xl sm:text-4xl font-bold mb-6">La visione.</h2>
          <p className="text-base text-[#C9C4B8] leading-relaxed mb-6">
            Wildersquad è un ecosistema in crescita: eventi, corsi, app, collezioni d'arte, esperienze culinarie,
            viaggi, moda, lifestyle. Un mondo per chi non si accontenta, per i giovani professionisti della
            ristorazione e dell'ospitalità che vogliono ispirarsi e crescere, per chi ama la bellezza in tutte le sue forme.
          </p>
          <p className="font-display text-2xl italic text-[#E4BD44] mb-8">Se ti riconosci in questa storia, sei già dei nostri.</p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/assaggi-darte" className="btn-primary">Vieni a un Assaggio d'Arte</Link>
            <Link to="/contatti" className="btn-outline">Scrivici</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
